module.exports = __webpack_public_path__ + "img/Tat-Sing-Logistics-Logo(White).9f0e1f02.png";